<template>
  <div class="journal-wrapper">
    <common-top :seconTitle="seconTitle"></common-top>
    <div class="journal-articl-content">
      <journal-slide></journal-slide>
      <div class="journal-detail-wrapper">
        <div class="journal-detail-content">
          <div id="images">
            <img v-for="item in detail" :key="'s'+item.id" class="img-item" :src="item.img" alt>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getYears, getMonths } from "@/filter";
import commonTop from "./commonTop";
import journalSlide from "./slide.vue";
import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
import { userApi } from "@/api/user.js";
export default {
  data() {
    return {
      seconTitle: "",
      detail: [],
      viewjsState: ""
    };
  },
  methods: {
    // scaleView() {
    //   this.viewjsState = new Viewer(document.getElementById("images"), {
    //     button: true,
    //     title: false, //是否显示当前图片的标题
    //     navbar: false, //是否显示导航缩略图
    //     toolbar: {
    //       prev: {
    //         size: "large"
    //       },
    //       zoomIn: {
    //         size: "large"
    //       },
    //       zoomOut: {
    //         size: "large"
    //       },
    //       next: {
    //         size: "large"
    //       }
    //       // zoomIn: 4,
    //       // zoomOut: 4,
    //       // oneToOne: 4,
    //       // reset: 4,
    //       // prev: 4,
    //       // play: {
    //       //   show: 4,
    //       //   size: "large"
    //       // },
    //       // next: 4,
    //       // rotateLeft: 4,
    //       // rotateRight: 4,
    //       // flipHorizontal: 4,
    //       // flipVertical: 4
    //     }
    //   });
    // },
    getDetail() {
      let _this = this;
      userApi
        .getjournalDetail({ journal_id: _this.$route.query.id })
        .then(res => {
          _this.detail = res.data;
          _this.$nextTick().then(function() {
            if(_this.viewjsState) {
              _this.viewjsState.destroy();
            }
            setTimeout(() => {
              _this.viewjsState = new Viewer(document.getElementById("images"), {
                button: true,
                title: false, //是否显示当前图片的标题
                navbar: false, //是否显示导航缩略图
                toolbar: {
                  prev: {
                    size: "large"
                  },
                  zoomIn: {
                    size: "large"
                  },
                  zoomOut: {
                    size: "large"
                  },
                  next: {
                    size: "large"
                  }
                  // zoomIn: 4,
                  // zoomOut: 4,
                  // oneToOne: 4,
                  // reset: 4,
                  // prev: 4,
                  // play: {
                  //   show: 4,
                  //   size: "large"
                  // },
                  // next: 4,
                  // rotateLeft: 4,
                  // rotateRight: 4,
                  // flipHorizontal: 4,
                  // flipVertical: 4
                }
              });
            }, 1000);
          });
        });
    }
  },
  mounted() {
    this.seconTitle =
      this.$route.query.year + "年第" + this.$route.query.num + "期";
    this.getDetail();
  },
    destroyed () {
    this.viewjsState.destroy();
  },
  watch: {
    $route() {
      this.seconTitle =
        this.$route.query.year + "年第" + this.$route.query.num + "期";
      this.getDetail();
    }
  },
  components: {
    commonTop,
    journalSlide
  }
};
</script>

<style scoped>
.img-item {
  width: 848px;
  display: block;
  box-shadow: 0 0 25px rgba(195, 205, 224, 0.7);
  margin-bottom: 20px;
}
.journal-articl-content {
  display: flex;
  align-items: flex-start;
}
.journal-wrapper {
  width: 1240px;
  margin: 0 auto;
}
.journal-list {
  padding: 70px 0 20px;
  box-sizing: border-box;
  width: 100%;
  background: #edf1f4;
  border-radius: 10px;
  border: 1px solid #edf1f4;
  position: relative;
  margin-bottom: 30px;
}
.journal-detail-wrapper {
  flex: 1;
  padding: 20px 0;
  background: #edf1f4;
  border-radius: 10px;
  margin-left: 30px;
  border: 1px solid #edf1f4;
}
.journal-detail-content {
  background: #fff;
  padding: 20px 25px;
  box-sizing: border-box;
}
</style>




// WEBPACK FOOTER //
// src/components/views/Journal/detail.vue